import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Reviews } from 'src/api';
import { SaveBtn, Input } from 'src/components/Common';
import createLogger from 'src/utils/logger';
import { Mixpanel } from '../../Mixpanel';

import './ShareNews.scss';

class ShareNews extends Component {
  constructor() {
    super();
    this.logger = createLogger('ShareNews');
    this.state = {
      news: '',
      newsErrors: [],
      sendingRequest: false,
      error: false,
    };
  }

  componentDidMount() {
    Mixpanel.track('Open add news');
  }

  shareNews = () => {
    Mixpanel.track('Send news')

    this.logger.info('shareNews()', this.state.news);
    this.setState({
      sendingRequest: true,
    });
    Reviews.createNews(this.state.news)
      .then((res) => {
        this.logger.info('shareNews() success:', res.data);
        toast.success('Материал успешно отправлен');
        this.setState({
          sendingRequest: false,
          news: '',
        });
      })
      .catch((err) => {
        this.logger.error('shareNews() error:', err.response.data);
        toast.error('Что-то пошло не так :(');
        this.setState({
          sendingRequest: false,
        });
      });
  }

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({ 
      news: e.target.value,
      newsErrors: [],
    });
  }

  render() {
    return (
      <div className="modal share-info">
        <div>
          <h1>Поделиться материалом</h1>
          <Input className="modal--input-block modal--input-block__column share-news--input"
            labelText=""
            name="news"
            placeholder="Ссылка на материал"
            value={this.state.news}
            onChange={this.handleInputChange}
            errors={this.state.newsErrors}
          />
          <SaveBtn saveText="Поделиться" cancelText="Отмена"
            onSave={this.shareNews} onCancel={this.props.closeModal}
            disabled={this.state.sendingRequest} />
        </div>
      </div>
    );
  }
}

ShareNews.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

export default ShareNews;



// WEBPACK FOOTER //
// ./src/components/Modal/ShareNews/index.js